export default __webpack_public_path__ + "static/media/3e3e15e638f4c3fdf841775a71b45191.png";